import { themeGet } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  gap: ${themeGet('spacing.md')};
  padding: ${themeGet('spacing.xl')};
`;
